import { useMemo } from 'react';
import { pick, prop } from 'ramda';
import { useParams } from 'react-router-dom';
import { IGame } from 'js/hooks/games/types';
import { getCleanUrl } from 'js/utils/url.util';
import { IPageState } from 'js/components/system/Page/store/types';
import { useAppSelector, useGameConfigurationSelector } from 'js/store/hooks';

export const useGetSEOTagsData = (page?: IPageState) => {
    const { param1: itemCodeParam } = useParams<{ param1: string }>();
    const gamesGridGameInfoPageURL = useAppSelector(prop('gamesGridGameInfoPageURL'));
    const games = useGameConfigurationSelector(prop('games'));

    return useMemo((): { robots?: string; keywords?: string; description?: string } => {
        if (!page) {
            return {};
        }

        const pageUrl = page.friendlyURL || getCleanUrl(page.path);

        switch (pageUrl) {
           case gamesGridGameInfoPageURL: {
               const { seoRobots, seoKeywords, seoDescription } = Object.values(games).find((gameItem) => {
                   return gameItem.seoFriendlyGameName === itemCodeParam || gameItem.gameCode === itemCodeParam;
               }) || {} as IGame;

               return {
                   ...pick(['robots', 'keywords', 'description'], page),
                   ...seoRobots && { robots: seoRobots },
                   ...seoKeywords && { keywords: seoKeywords },
                   ...seoDescription && { description: seoDescription }
               };
           }

           default: {
               return {
                   ...pick(['robots', 'keywords', 'description'], page)
               };
           }
       }
    }, [page, games, itemCodeParam, gamesGridGameInfoPageURL]);
};
